export const styles = () => ({
  container: { margin: 5 },
  label: { fontWeight: 'bold' },
  addresses: { marginTop: 10 },
})
